<template>
    <div id="virtual-doc" style="visibility: hidden;position: absolute;top: 0;left: 0;">

        <!--虚拟正文-->
        <div class="gw-element" id="virtual-content"
             style="visibility:hidden;position: absolute;left: 0;top: 0;width: 156mm;line-height: 10.39mm;letter-spacing: -0.4pt;word-break: break-all;font-family: 仿宋_GB2312;font-size: 16pt">
        </div>
        <doc-gutter id="virtual-head-gutter" height="35mm"></doc-gutter>
        <!--虚拟发文机关标识符-->
        <doc-draft-org-flag class="virtual" id="virtual-draft-org-flag" :item="doc.draftOrg"></doc-draft-org-flag>
        <!--虚拟附件-->
        <div class="virtual" id="virtual-attach" style="visibility: hidden;position: absolute;top: 0;left: 0;">
            <doc-attachment :item="doc.attachment"></doc-attachment>
        </div>
        <!--虚拟署名-->
        <div class="virtual" id="virtual-sign" style="visibility:hidden;position: absolute;top: 0;left: 0;">
            <doc-sign :item="doc.sign" :seal="doc.seal"></doc-sign>
        </div>
        <!--虚拟版记-->
        <div class="virtual" id="virtual-tail" style="visibility: hidden;position: absolute;top: 0;left: 0;">
            <doc-tail :cc-org="doc.ccOrg" :print-org="doc.printOrg" :to-org="doc.toOrg"></doc-tail>
        </div>
    </div>
</template>

<script>
    import DocDraftOrgFlag from "./DocDraftOrgFlag";
    import DocCode from "./DocCode";
    import DocDivider from "./DocDivider";
    import DocTitle from "./DocTitle";
    import DocToOrg from "./DocToOrg";
    import DocContent from "./DocContent";
    import DocAttachment from "./DocAttachment";
    import DocSign from "./DocSign";
    import DocTail from "./DocTail";
    import DocPage from "./DocPage";
    import DocSecret from "./DocSecret";
    import DocGutter from "./DocGutter";
    import DocVirtual from "./DocVirtual";

    export default {
        name: "DocVirtual",
        props: {
            doc: {},
        },
        components: {
            DocDraftOrgFlag,
            DocCode,
            DocDivider,
            DocTitle,
            DocToOrg,
            DocContent,
            DocAttachment,
            DocSign,
            DocTail,
            DocPage,
            DocSecret,
            DocGutter,
            DocVirtual
        },
        methods: {
            /**
             * 将文本转换为标准公文html格式
             * @param c
             * @returns {string}
             */
            convert(content, appendId) {
                return this.$tool.text2Html(content, appendId);
            }
        }
    }
</script>